import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to indicate error
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    // Log error to an error reporting service like Sentry, Bugsnag, etc.
  }

  render() {
    const { hasError } = this.state;

    // If an error occurred, display a customized error message
    if (hasError) {
      return (
        <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <h1>Something went wrong.</h1>
          <p>We apologize for the inconvenience. Please try refreshing the page or contact support.</p>
          <a href="/pawnshop-reports">Go back</a>
        </div>
      );
    }

    // Render the child components if no error occurred
    return this.props.children;
  }
}

export default ErrorBoundary;
